/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import GateLogCard from "./GateLogCard";
import DiscrepancyBanner from "./DiscrepancyBanner";
import {IconDocumentWarning} from "../../../../../../../components/buttons/IconButtons";

/**
 * Discrepancies the movement was reported with.
 *
 * A movement reported with discrepancies has to be reviewed before it can be
 * dispatched, so every detail that reads the folio displays who reported them
 * and the evidence that supports them above the gate log.
 *
 * @param {Object} props - Information of the review of the movement.
 * @param {Function} props.t - Translation handler.
 * @param {string} props.reviewedBy - Name of who reported the discrepancies.
 * @param {Date|string} props.reviewedAt - Date the discrepancies were reported.
 * @param {string} props.reason - Comment written when the discrepancies were reported.
 * @param {Array} props.files - Evidence of the report, when it does not hang from the materials.
 * @param {Object} props.contentRef - Reference of the content of the card.
 *
 * @returns {JSX.Element} Card with the discrepancies of the movement.
 */
const DiscrepancySection = ({t, reviewedBy, reviewedAt, reason, files = null}) => {
    return (
        <GateLogCard
            t={t}
            Icon={IconDocumentWarning}
            title={'discrepancy_details'}
        >
            <div className={"mb-3"}>
                <DiscrepancyBanner
                    t={t}
                    reviewedBy={reviewedBy}
                    reviewedAt={reviewedAt}
                    reason={reason}
                    files={files}
                />
            </div>
        </GateLogCard>
    );
};

export default DiscrepancySection;
